// Dependencies
import React, { FunctionComponent } from "react";

// Styles
import { Container } from "./styles";

// Types
type WebpBadgeProps = {
    size?: "regular" | "large";
    content: string | number;
};

export const WebpBadge: FunctionComponent<WebpBadgeProps> = ({ size = "regular", content }) => {
    return (
        <Container containerSize={size}>
            <div className="badge-container">
                <span className="badge-content">{content.toString()}</span>
            </div>
        </Container>
    );
};
